import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { PostUserKYCResponse, UpdateKYCStatusPayload } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number, kycUUID: string, data: UpdateKYCStatusPayload) =>
    makeCall<PostUserKYCResponse>(
      'PUT',
      `/api/v2/user/${userId}/kyc/${kycUUID}/status`,
      {
        data,
      },
    );
